<script>
import { mapGetters, mapActions } from 'vuex';
import { debounce } from 'lodash';


export default {
  data() {
    return {
      //localQuantity: 0,
      isUpdating: false
    }
  },
  watch: {
    basketQuantity: {
      immediate: true, // Это вызовет обработчик сразу при создании компонента
      handler(newVal) {
        this.updateLocalQuantity(newVal);
      }
    }
  },
  created() {
    // Создаем отложенную отправку на сервер
    this.syncWithServer = debounce(async (quantity) => {
      try {
        this.pendingUpdate = true;
        if (quantity == 0) {
          await this.removeFromCart(this.basketId);
        }
        else
          await this.setQuantity({
            id: this.basketId,
            quantity: quantity
          });
      } catch (error) {
        // В случае ошибки откатываем к серверному значению
        this.updateLocalQuantity(this.basketQuantity);
      } finally {
        this.pendingUpdate = false;
      }
    }, 500);
  },
  beforeUnmount() {
    this.syncWithServer.cancel();
  },

  computed: {
    ...mapGetters('counter', [
      'counterBasketData'
    ]),
    ...mapGetters('detail', ['localQuantity']),
    basketQuantity() {
      return (this.product?.id && this.counterBasketData.ids && this.counterBasketData.ids[this.product.id] &&  this.counterBasketData.ids[this.product.id].quantity) || 0;
    },
    basketId() {
      return (this.counterBasketData.ids && this.counterBasketData.ids[this.product.id].id) || 0;
    }
  },
  methods: {
    ...mapActions('basket',[
      'addToBasket',
      'setQuantity',
      'removeFromCart'
    ]),
    handleIncrement(quantity = 1) {
      if (this.localQuantity >=this.product.available) {
        this.updateLocalQuantity(this.product.available);
        return;
      }
      if ((this.localQuantity + quantity) > this.product.available)
        this.updateLocalQuantity(this.product.available);
      else
        this.updateLocalQuantity(this.localQuantity + quantity);

      this.syncWithServer(this.localQuantity);
    },

    handleDecrement(quantity = 1) {
      if (this.localQuantity <= 0) {
        this.updateLocalQuantity(0)
        return;
      }

      this.updateLocalQuantity(this.localQuantity - quantity);
      this.syncWithServer(this.localQuantity);
    },
    remove() {
      if (this.localQuantity <= 0) {
        this.updateLocalQuantity(0)
        return;
      }

      this.updateLocalQuantity(0);
      this.syncWithServer(0);
    },
    handleInput(event) {
      const value = parseInt(event.target.value);

      if (isNaN(value))
        return;
      // Проверяем валидность значения
      if (isNaN(value) || value < 0) {
        this.localQuantity = 0;
      } else if (value > this.product.available) {
        this.updateLocalQuantity(this.product.available);
      } else {
        this.updateLocalQuantity(value);
      }

      this.syncWithServer(this.localQuantity);
    },
    ...mapActions('detail', ['updateLocalQuantity']),
    formatPrice(value) {
      const rounded = Math.round(value * 100) / 100;
      return rounded % 1 === 0 ? rounded.toFixed(0) : rounded.toFixed(2);
    }
  }
}
</script>